import { Box, Typography } from "@mui/material";
import React from "react";

const Footer = () => {
  return (
    <Box
      className="Footer-section"
      sx={{
        display: "flex",
        flexWrap: "nowrap",
        width: "100%",
        gap: 2,
        paddingLeft: 1.27,
        // marginTop: 0.9,
        position: 'absolute',
        bottom: 15,

        "@media (max-width: 900px)": {
          display: "none",
        },
      }}
    >
      <Typography variant="body1">
        <a
          href="https://affirmate.app/terms/"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#FFFFFF",
            textDecoration: "none",
            fontWeight: 800,
            fontSize: "14px",
            lineHeight: "23.5px",
            fontFamily: "Roboto, sans-serif",
            letterSpacing: -0.1,
            wordSpacing: 0.4,
          }}
        >
          Terms of Service
        </a>
      </Typography>

      <Typography variant="body1">
        <a
          href="https://affirmate.app/privacy/"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#FFFFFF",
            textDecoration: "none",
            fontWeight: 800,
            fontSize: "14px",
            lineHeight: "23.5px",
            fontFamily: "Roboto, sans-serif",
            letterSpacing: 0,
          }}
        >
          Privacy Policy
        </a>
      </Typography>
    </Box>
  );
};

export default Footer;
